import { BackEndService } from '../../Services/back-end.service';
import { Component } from '@angular/core';
import { Router } from '@angular/router';

export class User {
  username: string;
  password: string;
}
@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.css']
})

export class LoginPageComponent {
  visabel = false;
  falschData = true;
  newUser = new User();
  username = '';
  pass = '';

  constructor(private backEndService: BackEndService, private router: Router) {
    this.falschData = true;
  }

  handelClick() {
    this.newUser.username = this.username;
    this.newUser.password = this.pass;
    this.backEndService.LogIn(this.newUser).subscribe(res => this.CheckLogin(res));
  }
  ZuruckFun() {
    document.location.href = 'https://fibudata.net/';
  }
  CheckLogin(res) {
    {
      console.log(res);
      if (res != null && res.res != null) {
        if (res.res && res.hash != null) {
          sessionStorage.setItem('token', res.hash);
          this.visabel = true;
          this.router.navigate(['/Folders']);
        }
      } else {
        this.falschData = false;
        sessionStorage.setItem('token', null);
      }
    }
  }
}
